import React from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TextInput,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * ListScreen - reusable list page (header + optional search/add + cards).
 * `items` = array of { title, subtitle, rows: [{label, value}], onPress }.
 */
const Card = ({ item }) => {
  const navigation = useAppNavigation();
  return (
    <TouchableOpacity
      activeOpacity={item.to ? 0.7 : 1}
      onPress={() => item.to && navigation.navigate(item.to)}
      style={styles.card}
    >
      {!!item.title && <Text style={styles.cardTitle}>{item.title}</Text>}
      {!!item.subtitle && <Text style={styles.cardSubtitle}>{item.subtitle}</Text>}
      {!!item.rows && (
        <View style={styles.grid}>
          {item.rows.map((r, i) => (
            <View key={i} style={[styles.field, r.full && { width: "100%" }]}>
              <Text style={styles.fieldLabel}>{r.label}</Text>
              <Text style={styles.fieldValue}>{r.value}</Text>
            </View>
          ))}
        </View>
      )}
    </TouchableOpacity>
  );
};

const ListScreen = ({ title = "List", search = "Search...", addTo, items = [] }) => {
  const navigation = useAppNavigation();
  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.header}>
        <View style={styles.row}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>{title}</Text>
        </View>
        <View style={styles.row}>
          <Image source={AppImages.Bellnoti} style={styles.bell} resizeMode="contain" />
          {!!addTo && (
            <TouchableOpacity onPress={() => navigation.navigate(addTo)} style={{ marginLeft: 18 }}>
              <Image source={AppImages.Plus} style={styles.plus} resizeMode="contain" />
            </TouchableOpacity>
          )}
        </View>
      </View>

      <View style={styles.searchWrap}>
        <TextInput
          placeholder={search}
          placeholderTextColor="#ACACAC80"
          style={styles.search}
        />
        <Image source={AppImages.search} style={styles.searchIcon} resizeMode="contain" />
      </View>

      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: 30 }}>
        {items.map((it, i) => (
          <Card key={i} item={it} />
        ))}
      </ScrollView>
    </SafeAreaView>
  );
};

export default ListScreen;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  row: { flexDirection: "row", alignItems: "center" },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  bell: { width: 16, height: 20 },
  plus: { width: 18, height: 18 },
  searchWrap: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: AppColors.sandal,
    borderRadius: 10,
    marginHorizontal: 20,
    marginTop: 20,
    paddingHorizontal: 12,
  },
  search: {
    flex: 1,
    paddingVertical: 10,
    fontSize: 12,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  searchIcon: { width: 17, height: 17 },
  card: {
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
    marginHorizontal: 20,
    marginTop: 16,
    padding: 16,
  },
  cardTitle: { color: AppColors.brown1, fontSize: 15, fontFamily: AppFonts.OverpassSemiBold },
  cardSubtitle: {
    color: AppColors.dualbrown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassRegular,
    marginTop: 4,
  },
  grid: { flexDirection: "row", flexWrap: "wrap", marginTop: 4 },
  field: { width: "50%", marginTop: 12 },
  fieldLabel: {
    color: AppColors.dualbrown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassRegular,
    marginBottom: 3,
  },
  fieldValue: { color: AppColors.brown1, fontSize: 14, fontFamily: AppFonts.OverpassSemiBold },
});
